
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[...path]",
      function () {
        return require("private-next-pages/p/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[...path]"])
      });
    }
  